
import Vue from "vue";
import {Bank, Purchase, Sale} from "@/models/base";
import AppSelectBankKind from "./SelectBankKind.vue";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
import {BankKind} from "@/models/base/bank";
import {DossierConfigService} from "@/services";
import AppSaleSearch from "@/components/sales/SaleSearchWithBrowseForBankEdit.vue";
import AppPurchaseSearch from "@/components/purchases/PurchaseSearchWithBrowse.vue";
import AppSelectBankFavorite from "./SelectBankFavorite.vue";
import { printHumanFloat } from "@/utils/pretty-print";
import { IBankBookingFavorite } from "@/models/dossier-configs/bank-config";
import { isSaleTypeAllowedForBankBookings } from "@/utils/bank-booking-sale-types";

export default Vue.extend({
	filters: {
		printHumanFloat
	},
	data() {
		return {
			batch: [] as  (Bank)[],
			config: DossierConfigService.getBookkeepingConfig(),
			hasFavorites: DossierConfigService.getBankConfig().Favorites.length > 0
		};
	},
	props: {
		bank: {
			type: Object as ()=>Bank,
			required: true
		},
	},
	computed: {
		disableLedgerInput(): boolean{
			return this.bank.Kind != BankKind.Diverse;
		},
		processedAmount():number{
			return this.batch.reduce((total, bank) => total + (bank.TotalDC || 0), 0);
		}
	},
	methods: {
		onBankKindInput(){},
		onLedgerAccountCode(){},
		cancel(){
			this.$emit("cancel");
		},
		addRule(){
			let b = new Bank(this.bank);
			b.Total = (this.bank.Total - this.processedAmount);
			b.TotalDC = (this.bank.TotalDC - this.processedAmount);
			this.batch.push(b);
		},
		clearSettings(index:number){
			if(this.batch[index].Kind == BankKind.Diverse){
				this.batch[index].LedgerAccountCode = this.config.DefaultSuspenseAccount;
			}else{
				this.batch[index].LedgerAccountCode = "";
			}
			this.batch[index].ContactID = 0;
			this.batch[index].InvoiceID = 0;
			this.batch[index].PurchaseID = 0;
			this.batch[index].FriendlyPurchaseID = "";
			this.batch[index].FriendlySaleID = "";
		},
		removeItem(index:number){
			this.batch.splice(index,1);
		},
		applyFavorite(favorite:IBankBookingFavorite, index:number){
			this.batch[index].Kind = favorite.Kind;
			this.clearSettings(index);
			if (favorite.Kind == BankKind.Diverse && favorite.LedgerAccountCode){
				this.batch[index].LedgerAccountCode = favorite.LedgerAccountCode;
			}
		},
		confirm(){
			this.$emit("confirm",this.batch);
		},
		selectSale(sale:Sale,index:number){
			if (!isSaleTypeAllowedForBankBookings(sale.TypeID)) {
				this.$wf.notify(this.$t("components.bank.booking-not-allowed-for-sale-type").toString(), "danger", 3000, "exclamation-triangle");
				return;
			}
			this.batch[index].Invoice = sale;
			this.batch[index].FriendlySaleID = sale.ComputedFriendlyID;
			this.batch[index].Contact = sale.Contact;
			this.batch[index].ContactID = sale.ContactID;
			this.batch[index].Purchase = null;
			this.batch[index].PurchaseID = 0;
			this.batch[index].FriendlyPurchaseID = "";
			if (this.batch[index].InvoiceID == sale.ID){
				return;
			}
			this.batch[index].InvoiceID = sale.ID;
			this.batch[index].Total = sale.TotalOpen;
			this.batch[index].TotalDC = sale.TotalOpen;
		},
		selectPurchase(purchase:Purchase,index:number){
			this.batch[index].Purchase = purchase;
			this.batch[index].FriendlyPurchaseID = purchase.ComputedFriendlyID;
			this.batch[index].PurchaseID = purchase.ID;
			this.batch[index].Total = purchase.TotalOpen;
			this.batch[index].TotalDC = -purchase.TotalOpen;
			this.batch[index].InvoiceID = 0;
			this.batch[index].Invoice = null;
			this.batch[index].FriendlySaleID = "";
			this.batch[index].Contact = purchase.Contact;
			this.batch[index].ContactID = purchase.ContactID;
		},
	},
	created(){
		this.batch.push(new Bank(this.bank));
	},
	components: {
		AppSelectBankKind,
		AppLedgerAccountAutocomplete,
		AppSaleSearch,
		AppPurchaseSearch,
		AppSelectBankFavorite
	},
	i18nEx: {
		componentPrefix: "components.bank.coda-split-modal"
	}
});
